import * as t from 'io-ts';
import { withFallback } from 'io-ts-types/lib/withFallback';
import { authorizedTo, id, meta } from '../..';
import { formCodec as entityTypePropertyFormCodec, recordCodec as entityTypePropertyRecordCodec } from '@/services/api/resources/entityTypeProperty/codec';

const data = t.type({
  title: t.string,
  description: withFallback(t.string, ''),
  properties: withFallback(t.array(entityTypePropertyRecordCodec), []),
});

export const recordCodec = t.type({
  id,
  data,
  authorizedTo,
});

export const listCodec = t.type({
  data: t.array(recordCodec),
  meta,
});

export const detailCodec = t.type({
  data,
  authorizedTo,
});

export const formCodec = t.type({
  title: t.string,
  description: withFallback(t.string, ''),
  properties: withFallback(t.array(entityTypePropertyFormCodec), []),
});
